"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaTokenService = exports.mediaTokenService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var getMediaToken = function (request) {
    var requestRoute = "mediaToken";
    var payload = {
        content: request.content,
        resourceId: request.resourceId,
    };
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: requestRoute,
        request: request,
    });
};
exports.mediaTokenService = {
    getMediaToken: getMediaToken,
};
var MediaTokenService = /** @class */ (function () {
    function MediaTokenService() {
        return exports.mediaTokenService;
    }
    return MediaTokenService;
}());
exports.MediaTokenService = MediaTokenService;
